// removed by extract-text-webpack-plugin
module.exports = {"modalBackground":"aQX6f97oYGeDWm4vyOiyT","modalBox":"B06jfwLe2Vi_54GnJiDGK","heading":"_1_EwIwIudXL6Pcw8RpNxuq","title":"abQJXUsFK6R-dTSqcEC7n","closeBtn":"_3gD4N1AfrnjdVPZXB7MdY3","content":"_10y1jY8TKv4DGiQSyWTcyw","contentItem":"_1PxwxFma6xRXzaonENrwLt","input":"_13bi6jovixIrd8RlEL6U1P","symbol":"_13cAYEX9oadUsdtgER8Kdv","dFlex":"_717wcg15A1Ymisf7mczzB","flagWrapper":"P6ha_1FQtl6c7niAROAHz","blockHeader":"_2YXkXV-_bcerxBkQQFqkzf","buttonWrapper":"mcKYtTMMnRsCJBW9oUyGT"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/IbpModal/IbpModal.styl
// module id = 735
// module chunks = 0